import React from "react";
import { Button, Spinner, Box } from "@chakra-ui/react";
function ExcelDownloadButton({
  onClick,
  loading = false,
  disabled = false,
  label = "Download Excel",
}) {
  return (
    <Button
      colorScheme="green"
      size={{ base: "sm", md: "md" }}
      onClick={onClick}
      isLoading={loading}
      loadingText="Downloading..."
      spinner={<Spinner size="sm" color="white" />}
      rightIcon={
        !loading ? (
          <Box as="span" fontSize={{ base: "14px", md: "18px" }}>⬇</Box>
        ) : null
      }
      w={{ base: "100%", sm: "auto" }}
      h={{ base: "32px", sm: "38px", md: "42px" }}
      px={{ base: 6, md: 9 }}
      fontSize={{ base: "xs", sm: "sm", md: "md" }}
      fontWeight="bold"
      boxShadow="0 2px 4px rgba(33,199,74,0.3)"
      _hover={{
        transform: loading ? "none" : "translateY(-2px)",
        boxShadow: loading
          ? "0 2px 4px rgba(33,199,74,0.3)"
          : "0 4px 8px rgba(33,199,74,0.4)",
      }}
      transition="all 0.2s"
      isDisabled={loading || disabled}
    >
      {label}
    </Button>
  );
}
 
export default ExcelDownloadButton;